// Mock data for SMA CONCEPT showcase website

export const companyInfo = {
  name: "SMA CONCEPT",
  tagline: "Votre expert en menuiserie et serrurerie",
  description: "Spécialiste de la menuiserie bois, PVC, aluminium et de la serrurerie. Bien implanté sur le bassin stéphanois et sur le reste de la France",
  phone: "06 20 60 41 66",
  email: "contact@sma-concept.fr",
  address: "2 Rue Sainte Catherine, 42000 Saint-Étienne"
};

export const services = [
  {
    id: 1,
    title: "Menuiserie Aluminium",
    description: "Solutions aluminium modernes et élégantes pour menuiserie extérieure : vérandas, baies coulissantes, portails, portes-fenêtres. Design contemporain et résistance exceptionnelle.",
    icon: "Building2",
    features: ["Vérandas", "Baies coulissantes", "Portails alu", "Portes-fenêtres alu"]
  },
  {
    id: 2,
    title: "Serrurerie",
    description: "Services de serrurerie complète : installation de portes blindées, serrures haute sécurité, dépannage d'urgence 24h/24.",
    icon: "Lock",
    features: ["Portes blindées", "Serrures sécurisées", "Dépannage urgent", "Contrôle d'accès"]
  },
  {
    id: 3,
    title: "Menuiserie PVC",
    description: "Installation de menuiseries PVC haute performance pour l'extérieur : isolation thermique et acoustique optimale. Produits durables et sans entretien.",
    icon: "RectangleHorizontal",
    features: ["Fenêtres PVC", "Portes-fenêtres", "Volets roulants", "Baies vitrées"]
  },
  {
    id: 4,
    title: "Menuiserie Bois",
    description: "Fabrication et installation de menuiseries bois sur mesure : portes, fenêtres, escaliers, parquets. Un savoir-faire artisanal allié à des techniques modernes.",
    icon: "TreeDeciduous",
    features: ["Portes intérieures", "Fenêtres bois", "Escaliers sur mesure", "Parquets massifs"]
  }
];

export const aboutContent = {
  title: "À propos de SMA CONCEPT",
  paragraphs: [
    "Depuis 2015, SMA CONCEPT s'impose comme une référence certifiée RGE dans le domaine de la menuiserie et de la serrurerie. Avec plus de 11 ans d'expérience, notre entreprise allie tradition artisanale et technologies modernes pour vous offrir des prestations de qualité supérieure.",
    "Notre certification RGE (Reconnu Garant de l'Environnement) vous permet de bénéficier d'aides financières pour vos travaux de rénovation énergétique : MaPrimeRénov', éco-PTZ, Certificats d'Économies d'Énergie (CEE). Nous vous accompagnons dans toutes vos démarches pour optimiser votre budget.",
    "Bien implanté sur le bassin stéphanois et intervenant sur toute la France, notre équipe de professionnels qualifiés met son expertise à votre service pour tous vos projets, qu'il s'agisse de constructions neuves ou de rénovations. Nous travaillons avec des matériaux nobles et durables pour garantir la longévité de nos installations.",
    "La satisfaction de nos clients est notre priorité. Nous vous accompagnons de A à Z dans votre projet : conseil, étude technique, fabrication sur mesure et installation soignée."
  ],
  values: [
    { title: "Certifié RGE", description: "Aides financières disponibles", icon: "Award" },
    { title: "11 ans d'expertise", description: "Depuis 2015", icon: "CheckCircle" },
    { title: "Réactivité", description: "Devis sous 48h", icon: "Clock" },
    { title: "Garantie", description: "SAV de qualité", icon: "Shield" }
  ]
};

export const galleryImages = [
  {
    id: 1,
    url: "/realisations/realisation-1.jpg",
    wide: true,
    title: "Fenêtres bois cintrées sur mesure - Appartement haussmannien, Saint-Étienne",
    category: "bois"
  },
  {
    id: 2,
    url: "/realisations/realisation-2.jpg",
    title: "Fenêtre bois cintrée à petits bois - Rénovation à l'identique",
    category: "bois"
  },
  {
    id: 3,
    url: "/realisations/realisation-3.jpg",
    title: "Remplacement de fenêtres bois - Vue sur les collines stéphanoises",
    category: "bois"
  },
  {
    id: 4,
    url: "/realisations/realisation-4.jpg",
    title: "Fenêtre bois ouvrante avec persiennes conservées",
    category: "bois"
  },
  {
    id: 5,
    url: "/realisations/realisation-5.jpg",
    title: "Escalier hélicoïdal métallique et passerelle industrielle",
    category: "serrurerie"
  },
  {
    id: 6,
    url: "/realisations/realisation-6.jpg",
    title: "Escalier droit galvanisé et garde-corps - Bâtiment industriel",
    category: "serrurerie"
  },
  {
    id: 7,
    url: "/realisations/realisation-7.jpg",
    title: "Garde-corps acier avec tôle perforée - Cage d'escalier",
    category: "serrurerie"
  },
  {
    id: 8,
    url: "/realisations/realisation-8.jpg",
    wide: true,
    title: "Rampe et garde-corps métalliques - Résidence collective",
    category: "serrurerie"
  },
  {
    id: 9,
    url: "/realisations/realisation-9.jpg",
    title: "Garde-corps découpé laser et escalier extérieur - Villa contemporaine",
    category: "serrurerie"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Dubois",
    role: "Particulier",
    content: "Excellent travail ! L'équipe de SMA CONCEPT a rénové toutes nos fenêtres en PVC. Le résultat est impeccable et l'isolation thermique incomparable. Je recommande vivement.",
    rating: 5,
    date: "Décembre 2024"
  },
  {
    id: 2,
    name: "Jean Martin",
    role: "Architecte",
    content: "Nous travaillons régulièrement avec SMA CONCEPT pour nos projets de construction. Leur professionnalisme et la qualité de leurs réalisations sont remarquables.",
    rating: 5,
    date: "Novembre 2024"
  },
  {
    id: 3,
    name: "Sophie Lefebvre",
    role: "Commerçante",
    content: "Suite à une effraction, j'ai fait appel à SMA CONCEPT pour sécuriser ma boutique. Installation rapide d'une porte blindée et serrure haute sécurité. Je me sens enfin en sécurité.",
    rating: 5,
    date: "Octobre 2024"
  },
  {
    id: 4,
    name: "Pierre Rousseau",
    role: "Particulier",
    content: "Création d'une magnifique véranda en aluminium. Le design est moderne, les finitions parfaites. L'équipe est à l'écoute et de bon conseil. Très satisfait !",
    rating: 5,
    date: "Septembre 2024"
  }
];

export const serviceTypes = [
  { value: "menuiserie-aluminium", label: "Menuiserie Aluminium" },
  { value: "menuiserie-pvc", label: "Menuiserie PVC" },
  { value: "menuiserie-bois", label: "Menuiserie Bois" },
  { value: "serrurerie", label: "Serrurerie" },
  { value: "autre", label: "Autre" }
];

// Mock function to simulate form submission
export const submitQuoteRequest = async (formData) => {
  // Simulate API call delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  // Mock success response
  console.log("Quote request submitted:", formData);
  
  return {
    success: true,
    message: "Votre demande de devis a été envoyée avec succès. Nous vous contacterons dans les 48h."
  };
};
